import React from 'react';
import { useField } from 'formik';
import { Form } from 'react-bootstrap';
import classNames from 'classnames';

import { FormCheckboxFieldProps, FormGroupFieldProps } from '../types';

import styles from './GroupCheckbox.module.scss';

type Props = {
  isRequired?: boolean;
};

const GroupCheckbox: React.FC<Props & FormGroupFieldProps & FormCheckboxFieldProps> = ({
  custom,
  error,
  children,
  isRequired = false,
  isInvalid,
  ...props
}) => {
  const [{ name }, { error: fieldError }] = useField(props);
  // const isInvalid = Boolean(fieldError) && touched;
  const requiredMark = isRequired ? <em className="text-danger px-1">*</em> : '';

  return (
    <Form.Check
      {...props}
      id={name}
      type="checkbox"
      className={classNames('pl-0', styles.checkbox, { 'is-invalid': isInvalid })}
      custom={custom}
    >
      {children}
      <Form.Check.Label className={classNames(props.className, 'pr-5 pl-0')} title={props.title}>
        {props.label} {requiredMark}
      </Form.Check.Label>
      <Form.Control.Feedback tooltip type="invalid">
        {!!error && fieldError}
      </Form.Control.Feedback>
    </Form.Check>
  );
};

export default GroupCheckbox;
